import React from "react";

function DeleveryManagementIcon({ stroke = "white", strokeWidth = "1.2" }) {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5996 4.60156V18.6016C18.5996 19.132 18.3889 19.6407 18.0138 20.0158C17.6387 20.3908 17.13 20.6016 16.5996 20.6016H2.59961C2.06918 20.6016 1.56047 20.3908 1.1854 20.0158C0.810323 19.6407 0.599609 19.132 0.599609 18.6016V4.60156L3.59961 0.601562H15.5996L18.5996 4.60156ZM0.599609 4.60156H18.5996M13.5996 8.60156C13.5996 9.66243 13.1782 10.6798 12.428 11.43C11.6779 12.1801 10.6605 12.6016 9.59961 12.6016C8.53874 12.6016 7.52133 12.1801 6.77118 11.43C6.02104 10.6798 5.59961 9.66243 5.59961 8.60156"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DeleveryManagementIcon;
